import React, {Component} from 'react';
import arrowLeft from './../img/arrow-pointing-left.png';


class DashboardMobile extends Component {
	state ={
		steps_datas : this.props.steps_data,
	    completed_steps : 0,
	    steps_number : 6,
	    showDashboard :true
	}
	constructor(props) {
		super(props);
		this.state.showDashboard =true;
	}
	Recommencer = ()=>{
		this.props.restart();
		this.forceUpdate()
	}
	goToResult = ()=>{

		this.setState({showDashboard:false});
		//this.props.displayDashboard();
	}
	componentDidUpdate = (prevProps,prevState)=>{		

		

		this.state.steps_datas= this.props.getRecapData();
		if (this.props.currentStep === 7) {
			this.state.completed_steps = 6;
		}else { 
			this.state.completed_steps = (Object.keys(this.state.steps_datas).reduce((sum,typeData)=>(
				this.state.steps_datas[typeData].saisi ? sum+1 :sum
			),0));
		}
		if (  prevProps.step !== this.props.step){
			this.setState({showDashboard:!prevState.showDashboard});
		}
	}

	moveStepTo = (step)=>{
		this.props.forceStep(step);
		//this.props.displayDashboard();
		this.setState({showDashboard:false})
		this.forceUpdate();
	}

	displayDashboard = ()=>{
		this.setState({showDashboard:true});
		//this.props.displayDashboard();
	}

	render() {
		const goToResult = this.goToResult;
		const Recommencer = this.Recommencer;
		const displayDashboard = this.displayDashboard;


		return <>
			{ (!this.state.showDashboard) ?
			<div className="dashboard-btn-container">
					<button className="show-dashboard-btn" onClick={displayDashboard}>
						<img  className="img-previous" src={arrowLeft}/>Tableau de bord
					</button>
			</div>
			:<div id="dashboard">
				<div className="dashboard-header">
					<p>
						Remplissez les diff&eacute;rents modules du <b className="bold">tableau de bord </b>
						et d&eacute;couvrez les aides qui correspondent à votre situation.
					</p>
					<h3 className="bold">Ça ne prend que 5 minutes !</h3>
				</div>
				<div className="step-box-container">
					{
						Object.keys(this.state.steps_datas).map((typeData,key)=>{
							let data = this.state.steps_datas[typeData];
						return <div className="half" key={key}>
							<div
								className={'step-box ' + (data.saisi ? 'completed': 'uncompleted')}
								onClick ={()=> (this.moveStepTo(data.step))}
								>
								<div className={"step-name "+ (data.available_datas.length > 0 ? 'has_data' : 'no_data')}>
									<img className="step-icon" src={data.icon_img}/>
									<h3>{data.title}</h3>
								</div>
								<div className={"step-datas "+ (data.available_datas.length > 0 ? 'has_data' : 'no_data')}>
									{ data.available_datas.map( (content,i)=> 
										<p key="i">{content}</p>
									)}
								</div>
								{ (data.saisi || data.is_current_step)?
								<div className="control-buttons"  >
									{!data.is_current_step ?
									  <p  className="control-button-modifier"><span><i className="fa fa-pencil"></i>&nbsp;Modifier</span></p>
									: <p ><span><i className="fa fa-pencil"></i>&nbsp;Continuer la simulation</span></p>
									}
								</div>
								:''
								}
							</div>
						</div>})}

					<div className="clear"></div>
					<div className="progress-bar-container">
						<div className="progress-bar" onClick={goToResult}>
							<div className="progression" style={{width:(this.state.completed_steps*100)/this.state.steps_number+"%"}}></div>
							{ this.props.currentStep !== 7 && this.state.completed_steps !== 6?

								<span className="progress-indication"> {this.state.completed_steps} / {this.state.steps_number} </span>
								: <span className="see-result bold">Voir les résultats</span>
							}
						</div>
					</div>

					<div className="text-center">
						<button onClick={Recommencer} className="btn btn-primary recommencer-button">
							Recommencer
						</button>
					</div>
				</div>	
			</div>}
		</>;
	}
}

export default DashboardMobile;